import _ from 'lodash'

export function cleanLayoutOrderTypes (layout, settingsBlob) {
  const orderTypes = _.get(settingsBlob, 'orderTypes.types', [])
    .filter(it => it.activePOS || it.activeOnline)
    .map(next => next.code)

  for (let layoutTab of _.values(layout.tabs)) {
    for (let button of _.values(layoutTab.buttons)) {
      const orderType = _.get(button, 'typeInfo.tenderInfo.orderType')
      if (orderType && !orderTypes.includes(button.typeInfo.tenderInfo.orderType)) {
        button.typeInfo.tenderInfo.orderType = null
      }
    }
  }
}
